module.exports = __webpack_public_path__ + "img/topgbqm_bg.7f06111b.png";